export enum PaymentModals {
    OPTIONS = 'OPTIONS',
    DIVIDE = 'DIVIDE',
    YOURITEMS = 'YOURITEMS',
    CUSTOM = 'CUSTOM',
    PAYMENT_METHODS = 'PAYMENT_METHODS',
}
